<button
    #origin="cdkOverlayOrigin"
    cdkOverlayOrigin
    mat-icon-button
    st-click-stop-propagation
    st-space-stop-propagation
    st-enter-stop-propagation
    [disabled]="disabled()"
    [matTooltip]="tooltip()"
    (click)="toggle()"
    (keydown.arrowdown)="onTriggerArrowDown($event)"
    (keydown.arrowup)="onTriggerArrowUp($event)">
    <mat-icon>add</mat-icon>
</button>

<ng-template
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="open()"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayPush]="true"
    (attach)="onOverlayAttached()"
    (backdropClick)="close()"
    (detach)="close()">
    <div
        #menuAnchor="cdkOverlayOrigin"
        cdkOverlayOrigin
        class="st-story-template-menu__container">
        <mat-form-field
            class="st-story-template-menu__search"
            subscriptSizing="dynamic">
            <mat-icon matPrefix>search</mat-icon>
            <input
                #searchInput
                matInput
                type="text"
                [value]="searchQuery()"
                [disabled]="disabled()"
                [placeholder]="i18n()?.PSTWebSearchPlaceholder ?? ''"
                (input)="onSearchInput(searchInput.value)" />
            <st-filter-trigger
                matSuffix
                [config]="filterConfig()"
                [state]="filterState()"
                [disabled]="disabled()"
                [overlayOrigin]="menuAnchor"
                [overlayPositions]="filterOverlayPositions"
                (stateChange)="filterStateChange.emit($event)"
                (save)="filterSave.emit()"
                (revert)="filterRevert.emit()"
                (clear)="filterClear.emit()" />
        </mat-form-field>

        <mat-selection-list
            #selectionList
            st-click-stop-propagation
            class="st-story-template-menu__list"
            (selectionChange)="onSelectionListChange($event)"
            (keydown)="onListKeydown($event)">
            @for (item of filteredTemplates(); track item?.Guid) {
                <mat-list-option
                    st-click-stop-propagation
                    class="st-story-template-menu__list__option"
                    [dir]="dir()"
                    [value]="item">
                    <st-story-icon
                        hasBorder
                        matListItemIcon
                        class="st-story-template-menu__list__option__icon"
                        [attr.disabled]="cardDisabled()"
                        [type]="item?.PSTStoryOutputType?.id"
                        [data]="item" />
                    <div matListItemTitle>{{ item?.Title }}</div>
                </mat-list-option>
            }
        </mat-selection-list>
    </div>
</ng-template>
